import { Box, ColorOptions, IconButton, IconOptions, Text } from '@jfs/ui-new'
import { useEffect } from 'react'

interface ToastMessageProps {
  show: boolean
  cardNumber: string
  duration?: number
  onCancel: () => void
  iconId?: IconOptions
  isCard: boolean
}
const ToastMessage = ({
  show,
  iconId = 'INFO',
  cardNumber,
  onCancel,
  duration = 3000,
  isCard = false,
}: ToastMessageProps) => {
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | any
    if (show) {
      timeout = setTimeout(onCancel, duration)
    }
    return () => clearTimeout(timeout)
  }, [show, onCancel, duration])

  if (!show) {
    return null
  }

  return (
    <Box
      flexDirection={'row'}
      backgroundColor={'#383838' as ColorOptions}
      position={'absolute'}
      bottom={0}
      ph={15}
      pv={10}
      zIndex={9999}
      width={'100%'}
      maxWidth={'100%'}
      justifyContent={'space-between'}
      alignItems={'center'}>
      <Box width={'80%'} flexDirection={'row'}>
        <IconButton id={iconId as IconOptions} size={20} color={'PRIMARY_GREY'} />
        <Text color={'PRIMARY_GREY'}>
          {`Your ${isCard ? 'card ending ' : 'VPA'}  `}
          <Text color={'WHITE'} fontWeight={'BOLD'}>
            {cardNumber}
          </Text>{' '}
          has been deleted successfully.
        </Text>
      </Box>
      <Box width={'20%'}>
        <Box alignSelf={'flex-end'}>
          <IconButton onPress={onCancel} id={'CLOSE'} size={20} color={'PRIMARY_GREY'} />
        </Box>
      </Box>
    </Box>
  )
}

export { ToastMessage }
